import { render, staticRenderFns } from "./ReportNew.vue?vue&type=template&id=1c4ecda2"
import script from "./ReportNew.vue?vue&type=script&lang=js"
export * from "./ReportNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports